import Job from "../../modules/crm/jobs/models/Job"
import Technician from "../../modules/technicians/models/technician"
import Avatar from "../base/Avatar"
import FlexRow from "../base/FlexRow"
import Icon from "../base/Icon"
import TechAvailabilityLabel from "../tech/TechAvailabilityLabel"
import TechLocationFreshnessLabel from "../tech/TechLocationFreshness"

interface IProps {
    tech: Technician
    inProgressJob?: Job
    distanceLabel?: string
}

export default function TechTooltip(props: IProps) {

    const busy = !!props.inProgressJob

    return (
        <div className="w-250px">
            <FlexRow>
                <Avatar width={40} avatarUrl={props.tech.avatar} className="me-3" />
                <div>
                    <div className="fw-bold fs-6 text-start">
                        {props.tech.fullName}
                    </div>
                    <div className="text-muted fs-8 text-start mt-1">
                        {props.tech.phoneItem?.phoneFriendly}
                    </div>
                </div>
            </FlexRow>

            <hr />

            <FlexRow className="text-start mb-2">
                <Icon icon="location-dot" type="regular" className="me-2" size={14} />
                <div className="fs-8 text-start">
                    {props.distanceLabel ?? props.tech.distanceLabel ?? "Unknown distance"}
                </div>
            </FlexRow>

            {/* How old the dot is. Picking the nearest technician off a position from this
                morning is picking the wrong one. */}
            <div className="fs-8 text-start mb-2">
                <TechLocationFreshnessLabel
                    techId={props.tech.id}
                    lastUpdate={props.tech.techLocationLastUpdate}
                    isWakeupAddress={!props.tech.techLocation}
                />
            </div>

            {
                busy ?
                    <div className="p-2 mt-2 rounded" style={{ background: "rgba(241, 65, 108, 0.08)" }}>
                        <div className="fs-7 fw-bold text-danger text-start mb-1">
                            <Icon icon="briefcase" type="solid" className="me-2" size={12} />
                            Working on a job
                        </div>
                        <div className="fs-8 text-start text-gray-800 fw-bold">
                            #{props.inProgressJob?.jobId}
                        </div>
                        <div className="fs-8 text-gray-700 text-start mt-1">
                            {props.inProgressJob?.address?.address?.label ?? props.inProgressJob?.address?.title ?? "-"}
                        </div>
                    </div>
                    :
                    <div className="fs-7 text-start mt-2">
                        <TechAvailabilityLabel availability={props.tech.availability} fallback="Ready for a job" />
                    </div>
            }
        </div>
    )
}
